import { fabric } from "fabric";
import { getFourPoints } from "@/utils/fabric-utils";
import useCanvas from "@/hooks/use-canvas";

interface RenderPolylineAsLaserOnCanvasProps {
  realtimeLaserPaths: any;
}

export const renderPolylineAsLaserOnCanvas = ({ realtimeLaserPaths }: RenderPolylineAsLaserOnCanvasProps) => {
  const [canvas] = useCanvas();

  if (!realtimeLaserPaths.value) return;

  const laserPathLine = canvas.getObjects().find((obj: any) => obj.id === "laser");

  if (realtimeLaserPaths.value.isDone && laserPathLine) {
    setTimeout(() => canvas.remove(laserPathLine), 1000);
    return;
  }

  canvas.remove(...canvas.getObjects().filter((obj: any) => obj.id === "laser"));

  realtimeLaserPaths.value.lines.forEach((data: any) => {
    const points = data.points?.length === 1 ? getFourPoints(data.points[0]) : data.points;
    new fabric.Polyline.fromObject({ points }, (item: any) => {
      Object.assign(item, {
        id: "laser",
        fill: "transparent",
        stroke: data.strokeColor,
        strokeWidth: data.strokeWidth,
        strokeLineCap: "round",
        strokeLineJoin: "round",
        skipCallback: true, // Skip handleAddObjectFromCanvas - synced via space.cursors
      });

      canvas.add(item);

      item.animate("opacity", `0`, {
        duration: 1000,
        easing: fabric.util.ease.easeInOutExpo,
        onComplete: () => {
          if (realtimeLaserPaths.value.isDone) canvas.remove(item);
        },
      });
    });
  });
};
